
namespace GeniuzPOS.Customer {

    @Serenity.Decorators.registerClass()
    //@Serenity.Decorators.panel()
    export class Report_1106CustomerDialog extends Serenity.EntityDialog<Report_1106CustomerRow, any> {
        protected getFormKey() { return Report_1106CustomerForm.formKey; }
        protected getIdProperty() { return Report_1106CustomerRow.idProperty; }
        protected getLocalTextPrefix() { return Report_1106CustomerRow.localTextPrefix; }
        protected getNameProperty() { return Report_1106CustomerRow.nameProperty; }
        protected getService() { return Report_1106CustomerService.baseUrl; }
        protected getDeletePermission() { return Report_1106CustomerRow.deletePermission; }
        protected getInsertPermission() { return Report_1106CustomerRow.insertPermission; }
        protected getUpdatePermission() { return Report_1106CustomerRow.updatePermission; }

        protected form = new Report_1106CustomerForm(this.idPrefix);

        constructor() {
            super();
            
           
        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
            return buttons;
        }

    }
}